/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Placeholder, PlaceholderImage, PlaceholderLine, Segment } from 'semantic-ui-react'
import React from 'react'

const placeholderResetCss = css`
    .ui.placeholder + .ui.placeholder {
        margin-top: 0;
    }
`

const PlaceholderSquare = () => {
    return (
      <Placeholder style={{height: 40, width: 40}}>
          <PlaceholderImage/>
      </Placeholder>
    )
}

const PlaceholderSquareLine = () => {
    return (
      <div
        css={css`
            display: flex;
            flex-direction: row;
            gap: .2rem;
            justify-content: flex-end;
            align-items: center;
            ${placeholderResetCss}
        `}
      >
          {Array.from({length: 24}, (_, index) => (
            <PlaceholderSquare key={index}/>
          ))}
      </div>
    )
}

const LoadingPlaceholder = ({ rowCount }) => {
    return (
      <Segment>
          <div
            css={css`
                display: grid;
                align-items: start;
                grid-template-columns: 1fr auto;
                margin-bottom: 1rem;
                margin-right: 2rem;
            `}
          >
              <Placeholder css={css`
                  height: 50px;
                  align-self: start;
              `}>
                  <PlaceholderLine/>
              </Placeholder>
              <Placeholder css={placeholderResetCss} style={{marginTop: 0, height: 150, width: 180}}/>
          </div>


          <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: .2rem;
            `}
          >
              {Array.from({length: rowCount || 3}, (_, index) => (
                <PlaceholderSquareLine key={`row-${index}`}/>
              ))}
          < /div>
      </Segment>
    )
}

export { LoadingPlaceholder }
